<template>
  <v-row dense no-gutters>
    <v-col cols="12">
      <v-card outlined class="pa-4 rounded-lg">
        <h3 class="mb-1">
          {{ $t('inputs.captations.type_cirurgy') }}<span style="color: red">*</span>
        </h3>
 
        <v-radio-group data-cy="radio-group-tipo-captacao" v-model="typeCaptationFlg" row :rules="formRules">
          <v-radio
            :data-cy="`radio-tipo-captacao-${type.slug}`"
            v-for="type in filteredTypeSurgery()"
            :key="type.slug"
            color="green"
            :label="type.description"
            :value="type.slug"
          />
        </v-radio-group>

        <v-row v-if="showSurgeryDateFields" dense>
          <v-col cols="12" sm="6">
            <v-text-field
              data-cy="campo-data-hora"
              class="rounded-lg"
              color="#086318"
              type="datetime-local"
              :rules="formRules"
              :max="maxDateTime"
              @input="onDateTimeInput('start_surgery', $event)"
              outlined
              dense
              v-model="captationsForm.start_surgery"
            >
              <template v-slot:label>
                {{ $t('inputs.captations.start_surgery_date_and_hour') }}
                <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6" v-if="showAorticFields">
            <v-text-field
              data-cy="data-hora-clampeamento-aorta"
              class="rounded-lg"
              color="#086318"
              type="datetime-local"
              :max="maxDateTime"
              @input="onDateTimeInput('aortic_clamping', $event)"
              :rules="formRules"
              outlined
              dense
              v-model="captationsForm.aortic_clamping"
            >
              <template v-slot:label>
                {{ $t('inputs.captations.aortic_clamping') }}
                <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6" v-if="showAorticFields">
            <v-text-field
              data-cy="campo-tempo-perfusao"
              class="rounded-lg"
              color="#086318"
              type="time"
              :rules="formRules"
              outlined
              dense
              v-model="captationsForm.perfusion_time"
            >
              <template v-slot:label>
                {{ $t('inputs.captations.perfusion_time') }} <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              data-cy="termino-cirurgia"
              class="rounded-lg"
              color="#086318"
              type="datetime-local"
              @input="onDateTimeInput('end_surgery', $event)"
              :rules="formRules"
              outlined
              dense
              v-model="captationsForm.end_surgery"
            >
              <template v-slot:label>
                {{ $t('inputs.captations.end_surgery') }}
                <span style="color: red">*</span>
              </template>
            </v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="isNoCaptation" dense>
          <v-col cols="12">
            <v-select
              class="rounded-lg"
              color="#086318"
              v-model="captationsForm.reason_not_captured_id"
              :rules="formRules"
              :items="reasonCaptations"
              @change="checkIfIsFamilyReason()"
              item-text="description"
              item-value="id"
              outlined
              dense
            >
              <template v-slot:label>
                {{ $t('inputs.captations.reason_not_captured') }}
                <span style="color: red">*</span>
              </template>
            </v-select>
          </v-col>
          <v-col cols="12" v-if="isFamilyReason">
            <v-textarea
              class="rounded-lg"
              color="#086318"
              v-model="captationsForm.reason_not_captured"
              :rules="formRules"
              outlined
              dense
            >
              <template v-slot:label>
                {{ $t('inputs.captations.reason_not_captured_description') }}
                <span style="color: red">*</span>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import dateTimeLimit from "@/utils/dateTimeLimit";
import {compareStr} from "@/utils/compareStrings";
export default {  
  props: {
    realized: { type: String, default: "" },
    captationsForm: { type: Object, required: true },
    formRules: { type: Array, required: true },
    maxDateTime: { type: String, default: "" },
    isPCRDonor: { type: Boolean, default: false },
    captureOnlyCorneas: { type: Boolean, default: false },
    reasonCaptations: { type: Array, default: () => [] },
    isFamilyReason: { type: Boolean, default: false },
    typeSurgery: { type: Array, default: () => [] },
  }, 

  mounted() {
    this.initTypeCaptation();
  },

  computed: {
    typeCaptationFlg: {
      get() { return this.realized; },
      set(val) { this.$emit("update:realized", val); },
    },

    showSurgeryDateFields() {
      return ['captou-orgao-e-tecidos', 'captou-apenas-orgaos', 'captou-apenas-tecidos'].includes(this.typeCaptationFlg);
    },

    showAorticFields() {
      return !['captou-apenas-tecidos'].includes(this.typeCaptationFlg);
    },

    isNoCaptation() {
      return this.typeCaptationFlg === 'nao-houve-captacao';
    },
  },

  methods: {
    initTypeCaptation() {
      if(this.captationsForm.type_captation) {
        this.typeCaptationFlg = this.captationsForm.type_captation.slug;
      }
    },

    filteredTypeSurgery() {
      if (!this.isPCRDonor && !this.captureOnlyCorneas) {
        return this.typeSurgery;
      }
      return this.typeSurgery.filter(
        type => type.slug != 'captou-orgao-e-tecidos' && type.slug != 'captou-apenas-orgaos'
      );
    },

    onDateTimeInput(field, value) {
      this.captationsForm[field] = dateTimeLimit.limitYearField(value);
    },

    checkIfIsFamilyReason() {
      const selectedReasonId = this.captationsForm.reason_not_captured_id;
      const reason = this.reasonCaptations.find(
        item => Number(item.id) === Number(selectedReasonId)
      );

      this.captationsForm.reason_not_captured_id = reason ? reason.id : null;
      this.captationsForm.reasonsForNotCaptureId = reason ? reason.description : null;
      this.$emit("update:isFamilyReason", reason ? compareStr(reason.description, "desistenciafamiliar") : false);
    },
  },
};
</script>
''